/*
 *  I13VENTCHAUFBOISCalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-06-27 11:12:23 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I13VENTCHAUFBOIS_State } from '@batical/types/src'

function I13VENTCHAUFBOIS_docalcul(state: I13VENTCHAUFBOIS_State) {
  const { in_puissanceh_chaufferie } = state
  state.res_ventil_basse = in_puissanceh_chaufferie * 12
  state.res_ventil_haute = (in_puissanceh_chaufferie * 12 * 2) / 3
  switch (state.lowOpen_uuid) {
    case '0':
      state.res_lowOpen = Math.sqrt(state.res_ventil_basse)
      break
    case '1':
      state.res_lowOpen = state.res_ventil_basse / state.in_longeur_basse
      break
    case '2':
      //SQRT(D6 / pi()) * 2
      state.res_lowOpen = Math.sqrt(state.res_ventil_basse / Math.PI) * 2
      break
    default:
      break
  }
  switch (state.highOpen_uuid) {
    case '0':
      state.res_highOpen = Math.sqrt(state.res_ventil_haute)
      break
    case '1':
      state.res_highOpen = state.res_ventil_haute / state.in_longeur_haute
      break
    case '2':
      //SQRT(D6 / pi()) * 2
      state.res_highOpen = Math.sqrt(state.res_ventil_haute / Math.PI) * 2
      break
    default:
      break
  }
  return state
}

export default I13VENTCHAUFBOIS_docalcul
